import React from 'react';
import useCurrentSurface from 'routes/surface/hooks/use-current-surface';
import useProtocolOperations from 'components/canvas/components/nodes/components/protocol-node/hooks/use-protocol-operations';
import useFindNodeInCache from 'components/canvas/hooks/use-find-node';
import { useLoggedUser } from 'state/user';
import { OnSubscriptionDataOptions, useSubscription } from '@apollo/client';
import { surfaceNodeUpdatedSubscription } from 'graphql/surface-node/subscriptions/surface-node-updated-subscription';
import apolloClient from 'services/apollo-client';
import { surfaceNodeMovedSubscription } from 'graphql/surface/subscriptions/surface-node-moved';
import { PROTOCOL_PADDING } from 'components/canvas/components/nodes/components/protocol-node/index';
import { SurfaceNodeUnion, SurfaceProtocolNode } from 'graphql/types';
import { isUndefined } from 'lodash';
import { AnyObject } from 'types';

export default function ProtocolNodeSubscriptionListeners({
  id,
  containingNodeId,
  isReference,
}: {
  id: string;
  isReference: any;
  containingNodeId?: string;
}) {
  const { id: surface } = useCurrentSurface();

  const { findProtocolContainingNodeShape } = useProtocolOperations();

  const { findNodeById } = useFindNodeInCache();

  const [loggedUser] = useLoggedUser();

  const draggedShapeIdMap = React.useRef({});

  const variables = { surface, user: loggedUser?.id };

  useSubscription(surfaceNodeUpdatedSubscription, {
    variables: { surface, user: 'all' },
    skip: isUndefined(loggedUser?.id),
    client: apolloClient,
    onSubscriptionData: subscriptionDataResolver((node: SurfaceNodeUnion) => {
      const wasContainingProtocolNodeUpdated =
        containingNodeId && containingNodeId === node.id;

      if (wasContainingProtocolNodeUpdated && isReference && containingNodeId) {
        // TODO
      }
    }),
    shouldResubscribe: true,
  });

  useSubscription(surfaceNodeMovedSubscription, {
    variables,
    skip: isUndefined(loggedUser?.id),
    fetchPolicy: 'no-cache',
    client: apolloClient,
    onSubscriptionData: subscriptionDataResolver(function (data) {
      const userIsMovingThisProtocol = data.id === id;

      if (userIsMovingThisProtocol) {
        if (containingNodeId) {
          const position = data.position;

          const protocolNode = findNodeById(data.id) as SurfaceProtocolNode;

          let shapeInstance = draggedShapeIdMap.current[id];

          if (parseInt(data.index) === 0) {
            shapeInstance = findProtocolContainingNodeShape(protocolNode);
            draggedShapeIdMap.current[id] = shapeInstance;
          }

          if (shapeInstance) {
            shapeInstance.x(position.x + PROTOCOL_PADDING);
            shapeInstance.y(position.y + PROTOCOL_PADDING);
          }
        }
      }
    }),
  });

  return null;
}

function subscriptionDataResolver(callback: (data: any) => void) {
  return function (options: OnSubscriptionDataOptions) {
    const data = Object.entries(
      options.subscriptionData.data,
    ).reduce<AnyObject>((data, [_, value]) => value as any, {});

    callback(data);
  };
}
